import * as actionTypes from '../constants/loadInfoConstants'

// 图书检索
export function changeStyle(data) {
    return {
        type: actionTypes.CHANGE_STYLE,
        data
    }
}


// WEBPACK FOOTER //
// ./src/actions/loadInfoActions.js